import { Typography, Card, Space } from 'antd';

import AppLayout from '../Components/Common/Layout';

const { Title, Paragraph } = Typography;

const Welcome = () => {
  return (
    <AppLayout selected="welcome">
      <Space
        direction="vertical"
        size="large"
        style={{ width: '100%', justifyContent: 'center', alignItems: 'center', minHeight: '60vh', display: 'flex' }}>
        <Card style={{ maxWidth: 500, width: '100%', textAlign: 'center', boxShadow: '0 2px 8px #f0f1f2' }}>
          <Title level={2}>Welcome!</Title>
          <Paragraph>
            Welcome to the Lumos platform. Please use the navigation menu to access your desired page.
          </Paragraph>
        </Card>
      </Space>
    </AppLayout>
  );
};

export default Welcome;
